import { Box, Grid, Skeleton } from "@mui/material";
import { useRouter } from "next/router";
import { Fragment, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  getArticleCategories,
  getBlogs,
} from "../../../redux/actions/advice_action";
import {
  ArticleSimilarGrid,
  BlogTitle,
  SimilarArticleContainer,
  SimilarArticleExcerpt,
  SimilarArticleWrapper,
  SimilarLinkStyled,
  SimilarTitle,
  StyledDivider,
  StyledSimilarCard,
  StyledSimilarCardActionArea,
  StyledSimilarCardContent,
  StyledSimilarCardMedia,
  ViewOtherButton,
  ViewOtherButtonContainer,
} from "./styles";

function AdviceArticleSimilar(props: any) {
  const { blog, SimilarArticles, setCheckSimilar } = props || {};

  const router = useRouter();
  const { i18n } = useTranslation();

  const dispatch: any = useDispatch();

  const categories = useSelector((state: any) => state?.advice?.categories);
  const blogs = useSelector((state: any) => state?.advice?.blogs);
  const fetchingBlogs = useSelector(
    (state: any) => state?.advice?.fetchingBlogs
  );
  const currentArticleCategory =
    blog?.attributes?.articleCategories?.data[0]?.attributes?.category;
  const currentCategoriesId = categories.filter(
    (category: any) => category?.attributes?.category == currentArticleCategory
  );

  const params = {
    categoryId: currentCategoriesId?.[0]?.attributes?.categoryId,
    locale:
      (i18n.resolvedLanguage || i18n.language)?.toString()?.toLowerCase()?.split("-")[0] ===
      "ms"
        ? "ms"
        : "en",
  };

  const filteredBlogs = blogs.filter(
    (article: any) =>
      article?.attributes?.slug != blog?.attributes?.slug &&
      article?.attributes?.articleCategories?.data[0]?.attributes?.category ==
        currentArticleCategory
  );

  useEffect(() => {
    dispatch(getArticleCategories());
    dispatch(getBlogs(params));
  }, [dispatch, i18n.language, i18n.resolvedLanguage]);

  function similarBlogs(blogs: any) {
    const selectedBlog = [];
    const selectedSimilar = [];
    let attempts = 6;

    while (selectedSimilar?.length < 3 && blogs?.length > 0 && attempts > 0) {
      const randomNumber = generateRandom(blogs?.length);
      attempts--;

      if (!selectedBlog.includes(randomNumber)) {
        selectedBlog.push(randomNumber);
        selectedSimilar.push(filteredBlogs[randomNumber]);
      }
    }
    setCheckSimilar(selectedSimilar?.length > 0);
    return selectedSimilar ?? [];
  }

  function generateRandom(length: number) {
    const randomNumber = Math.floor(Math.random() * length);

    return randomNumber;
  }

  const similarArticles = useMemo(() => {
    return similarBlogs(filteredBlogs);
  }, [filteredBlogs]);

  return (
    filteredBlogs?.length > 0 && (
      <ArticleSimilarGrid>
        <StyledDivider />
        <SimilarArticleWrapper ref={SimilarArticles}>
          <SimilarTitle id="similar">
            Similar Articles under {currentArticleCategory}.
          </SimilarTitle>
          <SimilarArticleContainer>
            {similarArticles || fetchingBlogs ? (
              similarArticles?.map((article) => (
                <Fragment>
                  <Grid key={article?.attributes?.articleId} width={"100%"}>
                    <SimilarLinkStyled
                      href={`/advice/${article?.attributes?.slug}`}
                      id={article?.attributes?.articleId}
                    >
                      <StyledSimilarCard
                        id={article?.attributes?.articleId}
                        key={article?.attributes?.articleId}
                      >
                        <StyledSimilarCardActionArea>
                          <StyledSimilarCardMedia
                            image={
                              article?.attributes?.coverImage?.data?.attributes
                                ?.url
                            }
                            title="advice-image"
                          />
                          <StyledSimilarCardContent>
                            <BlogTitle gutterBottom variant="h5">
                              {article?.attributes?.title}
                            </BlogTitle>
                            <SimilarArticleExcerpt
                              variant="body2"
                              color="text"
                              dangerouslySetInnerHTML={{
                                __html: article?.attributes?.excerpt,
                              }}
                            ></SimilarArticleExcerpt>
                          </StyledSimilarCardContent>
                        </StyledSimilarCardActionArea>
                      </StyledSimilarCard>
                    </SimilarLinkStyled>
                  </Grid>
                </Fragment>
              ))
            ) : (
              <Box
                width={"100%"}
                height={"100%"}
                display={"flex"}
                gap={"20px"}
                flexDirection={"row"}
              >
                <Grid
                  display={"flex"}
                  flexDirection={"column"}
                  width={"100%"}
                  height={"100%"}
                >
                  <Skeleton
                    variant="rectangular"
                    width={"100%"}
                    height={"100%"}
                    sx={{ borderRadius: "1.875rem" }}
                  />
                  <Skeleton width="60%" />
                  <Skeleton />
                  <Skeleton />
                </Grid>
                <Grid
                  display={"flex"}
                  flexDirection={"column"}
                  width={"100%"}
                  height={"100%"}
                >
                  <Skeleton
                    variant="rectangular"
                    width={"100%"}
                    height={"100%"}
                    sx={{ borderRadius: "1.875rem" }}
                  />
                  <Skeleton width="60%" />
                  <Skeleton />
                  <Skeleton />
                </Grid>
                <Grid
                  display={"flex"}
                  flexDirection={"column"}
                  width={"100%"}
                  height={"100%"}
                >
                  <Skeleton
                    variant="rectangular"
                    width={"100%"}
                    height={"100%"}
                    sx={{ borderRadius: "1.875rem" }}
                  />
                  <Skeleton width="60%" />
                  <Skeleton />
                  <Skeleton />
                </Grid>
              </Box>
            )}
          </SimilarArticleContainer>
        </SimilarArticleWrapper>
        <ViewOtherButtonContainer>
          <ViewOtherButton
            onClick={() => {
              router.push("/advice");
            }}
          >
            View Other Articles
          </ViewOtherButton>
        </ViewOtherButtonContainer>
      </ArticleSimilarGrid>
    )
  );
}

export default AdviceArticleSimilar;
